const YearSelector = ({value, onYearChange}) => {

    const handleYearChange = (event) => {
        onYearChange(event.target.value)
    }

    return (
        <select class="year" value={value} onChange={handleYearChange} data-testid="year-filter">
            <option value="Year">Year</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
        </select>
    )
}

export default YearSelector